(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-subcollection-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('subcollection-slider')) {
    class SubcollectionSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.update = this.update.bind(this);

        if (this.prev) this.prev.addEventListener('click', () => this.scrollByAmount(-1));
        if (this.next) this.next.addEventListener('click', () => this.scrollByAmount(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);

        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      scrollByAmount(direction) {
        const amount = this.track.clientWidth * 0.8 * direction;
        this.track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      update() {
        const t = this.track;
        const overflowing = t.scrollWidth - t.clientWidth > 2;
        this.toggleAttribute('data-overflow', overflowing);

        const atStart = t.scrollLeft <= 2;
        const atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
      }
    }

    customElements.define('subcollection-slider', SubcollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-accordions')) {
    class FooterAccordions extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 740px)');
        this.toggles = Array.from(this.querySelectorAll('[data-footer-accordion-toggle]'));
        if (!this.toggles.length) return;

        this.onClick = this.onClick.bind(this);
        this.apply = this.apply.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        this.toggles.forEach((toggle) => {
          toggle.addEventListener('click', this.onClick);
          const content = toggle.nextElementSibling;
          if (content) content.addEventListener('transitionend', this.onTransitionEnd);
        });

        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', this.apply);
        } else if (this.mq.addListener) {
          this.mq.addListener(this.apply);
        }

        this.apply();
      }

      apply() {
        const mobile = this.mq.matches;
        this.toggles.forEach((toggle) => {
          const content = toggle.nextElementSibling;
          if (!content) return;
          if (mobile) {
            toggle.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0px';
          } else {
            toggle.setAttribute('aria-expanded', 'true');
            content.style.maxHeight = '';
          }
        });
      }

      onClick(event) {
        if (!this.mq.matches) return;
        const toggle = event.currentTarget;
        const content = toggle.nextElementSibling;
        if (!content) return;

        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          // pin current height, then collapse on the next frame so the transition runs
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
            content.style.maxHeight = '0px';
          });
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      }

      onTransitionEnd(event) {
        if (event.propertyName !== 'max-height') return;
        const content = event.currentTarget;
        const toggle = content.previousElementSibling;
        if (this.mq.matches && toggle && toggle.getAttribute('aria-expanded') === 'true') {
          content.style.maxHeight = 'none';
        }
      }
    }

    customElements.define('footer-accordions', FooterAccordions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('facet-top-toggle')) {
    class FacetTopToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-facet-top-button]');
        this.panel = this.querySelector('.product-facet__top-panel');
        if (!this.button || !this.panel) return;

        this.desktop = window.matchMedia('(min-width: 1000px)');
        this.handleClick = this.handleClick.bind(this);
        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);

        this.button.addEventListener('click', this.handleClick);
        this.panel.addEventListener('transitionend', this.handleTransitionEnd);

        // Start collapsed on desktop; on mobile the panel is governed by the theme's drawer CSS.
        if (this.desktop.matches && !this.expanded) {
          this.panel.style.maxHeight = '0px';
        }
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.handleClick);
        if (this.panel) this.panel.removeEventListener('transitionend', this.handleTransitionEnd);
      }

      get expanded() {
        return this.panel.classList.contains('is-expanded');
      }

      handleClick() {
        if (this.expanded) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.panel.classList.add('is-expanded');
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.style.maxHeight = this.panel.scrollHeight + 'px';
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        // Pin current height, then collapse to 0 on the next frame so the transition runs.
        this.panel.style.maxHeight = this.panel.scrollHeight + 'px';
        requestAnimationFrame(() => {
          this.panel.classList.remove('is-expanded');
          this.panel.style.maxHeight = '0px';
        });
      }

      handleTransitionEnd(event) {
        // Once open, release the height cap so updated counts / re-rendered filters can grow.
        if (event.propertyName === 'max-height' && this.expanded) {
          this.panel.style.maxHeight = 'none';
        }
      }
    }

    customElements.define('facet-top-toggle', FacetTopToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('menu-slider')) {
    class MenuSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.update = this.update.bind(this);

        if (this.prev) this.prev.addEventListener('click', () => this.scrollByAmount(-1));
        if (this.next) this.next.addEventListener('click', () => this.scrollByAmount(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);

        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      scrollByAmount(direction) {
        const amount = this.track.clientWidth * 0.8 * direction;
        this.track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      update() {
        const t = this.track;
        const overflowing = t.scrollWidth - t.clientWidth > 2;
        this.toggleAttribute('data-overflow', overflowing);

        const atStart = t.scrollLeft <= 2;
        const atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
      }
    }

    customElements.define('menu-slider', MenuSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
